import React from 'react'

import RegsistrationFormSection from './RegistrationFormSection'
import RegistrationFormRow from './RegistrationFormRow';
import useApiUrlTranslation from './useApiUrlTranslation';

const RegistrationFormProfilCooperationSection = ({ formulaire, contact }) => {

    const { t, i18n, apiUrlTranslation } = useApiUrlTranslation();

    return (
        <RegsistrationFormSection

            title={formulaire.profil_section_title}
            instructions={formulaire.profil_section_instructions}>

            <RegistrationFormRow
                isRegister
                inputType="textarea"
                name='profil_cooperation'
                placeholder={

                    'profil description'     //    t('form.sections.organisme_section.edito_long')
                }
                required={false}
                defaultValue={contact?.profil_cooperation} />

        </RegsistrationFormSection>
    )
}

export default RegistrationFormProfilCooperationSection;